import { RootState } from 'editor/src/store/index';

const getBackgroundColor = (state: RootState) => state.hostSettings.backgroundColor || '#f7f7f7';

export default getBackgroundColor;
